// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__6aswQ","image":"Header_image__ijUZU","name":"Header_name__3yiIu","info":"Header_info__1P4MO","infoRow":"Header_infoRow__29c0k"};